import ChartLockIssueService from '@/Service/ChartLockIssueService'
import React, { useState } from 'react'
import { DialogContent, DialogHeader, DialogTitle } from '@/Components/ui/dialog'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { toast } from 'react-toastify'
import Loader from '@/Components/Common/Loader'

const CreateChartLockIssue = ({ getChartLockIssue, setIsOpen }) => {
    const formSchema = z.object({
        chart_lock_issue: z
            .string({
                message: 'Chart Lock Issue is required.',
            })
            .min(1, {
                message: 'Chart Lock Issue is required.',
            }),
    })
    const [isSaving, setIsSaving] = useState(false)

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            chart_lock_issue: '',
        },
    })

    async function onSubmit(values) {
        try {
            setIsSaving(true)
            const resp = await ChartLockIssueService.createChartLockIssue(values)
            if (resp.data.success) {
                setIsSaving(false)
                const searchParams = new URLSearchParams(location.search)
                const page = searchParams.get('page')
                if (page) {
                    navigate('/setup/chart-lock-issue')
                } else {
                    getChartLockIssue()
                }
                form.reset({ chart_lock_issue: '' })
                setIsOpen(false)
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        }
        console.log(errors, e)
    }

    return (
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Add Chart Lock Issue</DialogTitle>
            </DialogHeader>
            <div>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit, onError)} className="space-y-4">
                        <FormField
                            control={form.control}
                            name="chart_lock_issue"
                            render={({ field }) => (
                                <FormItem className="space-y-1">
                                    <FormLabel required={true}>Chart Lock Issue</FormLabel>
                                    <FormControl>
                                        <Input
                                            {...field}
                                            className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                            placeholder="Chart Lock Issue"
                                            onChange={(e) => {
                                                field.onChange(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </FormItem>
                            )}
                        />

                        <div className="flex justify-end">
                            <Button type="submit" className="bg-primary-purpal hover:bg-primary-purpal " disabled={isSaving}>
                                Submit {isSaving && <Loader fullScreen={false} />}
                            </Button>
                        </div>
                    </form>
                </Form>
            </div>
        </DialogContent>
    )
}

export default CreateChartLockIssue
